<template>
  <v-app id="guaranteeFact">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="2">
            <v-select v-model="Param1.maandKeuze" :items="maandCodes" item-value="maandCode"  item-text="maandOms" label="Year / Month"></v-select>
          </v-col>
      </v-row>  
     
            <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="submitted" @click="ovrz">Create Proforma Guarantee Invoices</v-btn>
          </v-col> 
      </v-row>

    </v-container>
     <showProgress ref="showProgress"></showProgress>
    </v-main>
    <navBar title="Ares - Finance" :home="true" type="hefc"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import showProgress from "@/components/showProgress.vue";
 export default {
  components: {
    navBar,
    showProgress
  },
  data() {
    return {
      bedrCodesSelected: [],
      bedrCodes: [],
      maandCodesSelected: '',
      maandCodes: [],
      submitted: false,
      Param1: {}
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/eign/hefc/guarantee/getFactParam.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getFactParam"
        },
        getFactParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.Param1 = res.data.getFactParam; 
           res.data.getFactParam.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
           res.data.getFactParam.maandKeuzes.forEach(function(maand) {
             deze.maandCodes.push(maand);
           });
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.submitted = true;
      this.$refs.showProgress.open();
      this.$axios
        .post("ares/json/ares/eign/hefc/guarantee/createFact.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: ""
          },
          createFact: {
            bedr_codes: this.bedrCodesSelected,
            maandJaar: this.Param1.maandKeuze,
            destination: this.Param1.destKeuze
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.createFact;
            this.$refs.showProgress.close();
            this.submitted = false;
            this.$router.reload('/eign/hefc/searchHefcTmp');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
